import { sizer } from "layout/styles/styled/sizer";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { Timeline } from "primereact/timeline";
import styled from "styled-components";

interface IStyledPageContainerProps {
  maxWidth?: string;
  minWidth?: string;
}

export const HorizontalLine = styled.hr`
  border-top: 1px solid #e2e2e4;
`;

export const StyledPageContainer = styled.div<IStyledPageContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth || "672px"};
  min-width: ${({ minWidth }) => minWidth || "672px"};
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 48px;

  p {
    color: #706f7b;
  }
  .purple {
    color: #4f46e5;
  }
  .dark-gray {
    color: #2f2a89;
  }
  .green {
    color: #027a48;
  }
  .light-green {
    color: #07a685;
  }
  .red {
    color: #d92d20;
  }
  .highlighted {
    color: #17143f;
  }
  .gray-text {
    color: #344054;
  }
  .light-gray {
    color: #706f7b;
  }

  @media (max-width: 672px) {
    min-width: 100%;
    width: 100%;
    margin-top: 20px;
  }
`;

export const StyledSectionContainer = styled.div`
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 16px;
  .gray {
    color: #858490;
  }
  .shadow {
    box-shadow: 0px 5px 10px 0px rgba(18, 12, 96, 0.06),
      0px 2px 2px 0px rgba(17, 12, 96, 0.1);
  }
`;

export const StyledSelectButton = styled(SelectButton)<{
  $buttonWidth?: number;
  $buttonFontSize?: number;
  $buttonPaddingTop?: number;
  $buttonPaddingBottom?: number;
}>`
  margin-top: 24px;
  width: 100%;
  padding: 4px;
  border: 1px solid #d0ccfe;
  background-color: #f6f8fe;
  border-radius: 10px;
  .p-button {
    vertical-align: middle;
    ${({ $buttonPaddingTop }) =>
      $buttonPaddingTop && `padding-top: ${$buttonPaddingTop}px;`}
    ${({ $buttonPaddingBottom }) =>
      $buttonPaddingBottom && `padding-bottom: ${$buttonPaddingBottom}px;`}
  }
  .p-component {
    width: ${({ $buttonWidth }) => $buttonWidth || 50}%;
    border: none;
    background: transparent;
    color: #a5a4ad;
    font-size: ${({ $buttonFontSize }) => $buttonFontSize || 14}px;
    font-weigth: 600;
    line-height: 20px;
    :hover {
      background: transparent;
    }
  }
  .p-selectbutton .p-button.p-highlight {
    border-radius: 6px !important;
  }
  .p-button:first-of-type,
  .p-button:last-of-type {
    border-radius: 6px;
    padding-left: 7px;
    padding-right: 7px;
  }
  .p-button:not(.p-disabled):not(.p-highlight):hover {
    background: transparent !important;
    border: none;
    color: #a5a4ad;
  }

  .p-component.p-highlight .p-tag.p-tag-success {
    background-color: #ecfdf3 !important;
    color: #027a48;
    border-color: #ecfdf3;
  }

  .p-tag.p-tag-success {
    background-color: #ececed !important;
    border-radius: 16px;
    padding: 2px 8px 2px 8px;
    width: fit-content;
    color: #a5a4ad;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    border: 1px solid #ececed;
  }
`;

export const StyledPriceContainer = styled.div`
  background: #f6f8fe;
  border-radius: 12px;
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  gap: 30px;
  @media (max-width: 640px) {
    gap: 25px;
  }
`;

export const StyledTimeline = styled(Timeline)`
  font-size: 14px !important;
  max-height: 250px;
  overflow-y: auto;
  .p-timeline-event-opposite {
    display: none;
  }
  .p-timeline-event-content {
    padding-top: 0px !important;
    padding-right: 0px !important;
  }
  .p-timeline-event {
    min-height: 50px;
  }
  .p-timeline-event-connector {
    background-color: #e2e2e4;
  }
  .p-timeline-event-marker {
    border-color: #d0ccfe;
    background-color: transparent;
    width: 20px;
    height: 20px;
  }
  .p-timeline-event:first-child .p-timeline-event-marker {
    border-color: #f6f8fe;
    box-shadow: 0px 4px 5px -1px rgba(0, 0, 0, 0.18);
    background-color: #584dfd;
    position: relative;
    border-width: 1.5px;
  }
  .p-timeline-event:first-child .p-timeline-event-marker::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 7px;
    background-color: #f6f8fe;
    border-radius: 50%;
  }
`;

export const StyledTag = styled(Tag)`
  .p-tag-value {
    liine-height: 1;
  }
`;

export const StyledButton = styled(Button)`
  gap: ${sizer(2)};
  margin-bottom: ${sizer(4)};

  span:first-child {
    font-size: ${sizer(3)};
  }
`;

export const StyledBreadcrumbContainer = styled.div`
  display: flex;
  width: 100%;

  @media (min-width: 1024px) {
    padding-left: 96px !important;
    padding-right: 96px !important;
  }
`;

export const StyledBreadCrumb = styled(BreadCrumb)`
  border: none;
  padding: 0px;
  font-size: 14px;
  ul > li:first-child {
    display: none;
  }
  span {
    color: #706f7b !important;
  }
  .active {
    color: #4f46e5 !important;
  }
  button {
    color: #706f7b !important;
    font-size: 14px !important;
    padding: 0px !important;
  }
  button:hover {
    background-color: transparent !important;
  }

  /* Hide the default chevron */
  .p-breadcrumb-chevron::before {
    content: "/";
    font-family: inherit;
    font-size: 1rem;
    color: #706f7b;
  }
  .p-button: focus {
    box-shadow: none !important;
  }
`;

export const StyledInsuranceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  padding: 15px 8px;
  margin-top: 12px;
  background-color: #f6f8fe;
`;

export const StyledDataTable = styled(DataTable)`
  width: 100%;
  .p-datatable-table {
    min-width: 100% !important;
  }
  .p-datatable-tbody > tr > td {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #344054;
  }
  .p-datatable-thead > tr > th > div > .p-column-title {
    color: #17143f;
    font-size: 14px;
    font-weight: 500 !important;
  }

  .p-datatable-tfoot > tr > td {
    color: #17143f;
    font-weight: 500 !important;
    font-size: 14px;
  }
  @media (max-width: 672px) {
    .p-datatable-tbody > tr > td {
      font-size: 12px !important;
    }
    .p-datatable-thead > tr > th > div > .p-column-title {
      font-size: 12px;
    }
    .p-datatable-tfoot > tr > td,
    .p-datatable-tfoot > tr > th {
      font-size: 12px !important;
      font-weight: 500 !important;
    }
    .p-datatable-thead > tr > th,
    .p-datatable-tbody > tr > td,
    .p-datatable-tfoot > tr > td,
    .p-datatable-tfoot > tr > th {
      padding: 0.5rem 0.3rem;
    }
  }
`;

export const StyledNonCoveredContainer = styled.div`
  background-color: #f6f8fe;
  padding: 15px 8px;
  border-radius: 12px;
  border: 1px solid #e2e2e4;
  gap: 5px;
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: var(--gray-50);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom: 1px solid #e2e2e4;
`;

export const StyledProceduresListContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  border: 1px solid #d0ccfe;
  background-color: #f6f8fe;
  border-radius: 12px;
`;

export const StyledProcedureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #ecebff;
  border-radius: 4px;
  background-color: #ffffff;
  justify-content: space-between;
  padding: 16px;
`;

export const StyledProcedureItem = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

export const CanvasContainer = styled.div<{ $disabled?: boolean }>`
  position: relative;
  border: 2px dashed #d1d5db;
  border-radius: 0.5rem;
  background-color: ${(props) => (props.$disabled ? "#f3f4f6" : "#ffffff")};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "crosshair")};
  overflow: hidden;

  &:hover {
    border-color: ${(props) => (props.$disabled ? "#d1d5db" : "#9ca3af")};
  }
`;

export const Canvas = styled.canvas<{ $disabled?: boolean }>`
  display: block;
  touch-action: none;
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
`;

export const EmptyStateText = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #9ca3af;
  font-size: 0.875rem;
  pointer-events: none;
  user-select: none;
`;

export const StyledSuccessContainer = styled.div`
  max-width: 640px;
  p {
    color: #706f7b;
  }
  .purple {
    color: #4f46e5;
  }
  .gray {
    color: #858490;
  }
  .message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -2px;
  }

  .highlighted {
    color: #17143f;
  }

  .p-divider {
    height: 1px;
    background: #d3d2d5;
  }

  button {
    color: #4f46e5 !important;
  }
`;
